import styled from 'styled-components';

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 10px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		transition: filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledButtonContent, StyledButtonsContainer };
